import { Money } from 'types';
import { Money as MoneyTypes } from 'Money/types';

export interface DayPrice {
	price: Money;
	hasFlight: boolean;
}

export interface Prices {
	[dateString: string]: DayPrice;
}

export interface MonthsMap {
	[startMonth: string]: {
		minPrice: Money;
		maxPrice: Money;
	};
}

export interface MonthMoney {
	dateISO: string;
	minPrice: MoneyTypes;
}

export enum RouteType {
	Outbound,
	Return
}

export interface ArrowAction {
	currentOffset: number;
	nextOffset: number;
	direction: 'right' | 'left';
	itemsOutsideBoundary: number;
}

export interface PriceGraphProps {
	// Centered date
	openDate: Date;

	// Selected date for departure flight
	outDate?: Date;

	// Opened tab
	routeType?: RouteType;

	// Round trip mode is enabled.
	isRoundTrip?: boolean;

	// Selected date for back flight
	backDate?: Date;

	departureCity?: string;
	arrivalCity?: string;

	/**
	 * Date select handler
	 * @param {Date} date
	 * @param {boolean} isBackDate - is date for back flight
	 */
	onSelect?: (date: Date, isBackDate?: boolean) => void;

	// Object of prices
	prices: Prices;

	/**
	 * When user changed month
	 * @param {Date} date
	 */
	onMonthChange?: (date: Date) => void;

	/**
	 * When there is no prices for next month
	 * @param {Date} date
	 */
	onPricesEnd?: (date: Date, direction: 'next' | 'prev') => void;
}
